import { Button, Card } from '@superops/ui-design-system';
import React, { useEffect, useState } from 'react';
import { Image } from '@nile/components/src/Components/Nodata';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage } from 'react-intl';
import { toast } from '@nile/components';
import { AccountClient } from '@nile/graphql';
import { GET_REPORT_DATA } from '@nile/reports/src/modules/DataReports/graphql';
import DataReportTable from '@nile/reports/src/modules/DataReports/components/subpages/DataReportTable';
import { DATA_REPORT_TYPE } from '@nile/reports/src/modules/home/constants';

function DataReportDetail(props) {
  const {
    data,
    isSameData = false,
    originalData,
    meta,
    validateFormData
  } = props;
  const [reportLoading, setReportLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showPreview, setShowPreview] = useState(false);

  const previewWidget = async (isPreview = false, listInfo = {}) => {
    if (data.reportId || isPreview) {
      setReportLoading(true);
      const input = isPreview
        ? {
            entity: data?.entity,
            reportType: DATA_REPORT_TYPE,
            selectAttributes: data?.selectAttributes,
            groupBy: data?.groupBy,
            condition: data?.dataCondition,
            page: listInfo.page,
            pageSize: listInfo.pageSize
          }
        : {
            reportId: data?.reportId,
            reportType: DATA_REPORT_TYPE,
            page: listInfo.page,
            pageSize: listInfo.pageSize
          };
      AccountClient.query({
        query: GET_REPORT_DATA,
        variables: {
          GetReportDataInput: input
        },
        fetchPolicy: 'network-only'
      })
        .then(({ data: previewData }) => {
          if (previewData?.getReportData) {
            if (isPreview) setShowPreview(true);
            setTableData(previewData?.getReportData);
            setReportLoading(false);
          } else {
            setReportLoading(false);
          }
        })
        .catch((err) => {
          setReportLoading(false);
          toast('error', 'common.error');
        });
    }
  };

  useEffect(() => {
    if (showPreview) {
      setShowPreview(false);
    }
  }, [data?.selectAttributes, data?.groupBy, data?.dataCondition]);

  useEffect(() => {
    setShowPreview(false);
    if (originalData) previewWidget(false, { page: 1, pageSize: 100 });
  }, [JSON.stringify(originalData)]);

  const sameConfig = isSameData();

  if (!sameConfig && !showPreview) {
    return (
      <div className="full-height">
        <Card AdaptHeight padding="sizeSmall">
          <div className="full-height fx jctr col">
            <div className="flex actr jctr">
              <Image
                url={`url(${envConfig.imageRoot}svg/EmptyChartNew.svg)`}
                height="150px"
                width="200px"
              />
            </div>
            <div className="flex actr jctr mt10">
              <Button
                primary
                onClick={() => {
                  const validResult = validateFormData();
                  if (validResult) {
                    return;
                  }
                  previewWidget(true, { page: 1, pageSize: 100 });
                }}
                loading={reportLoading}
              >
                <FormattedMessage id="reports.datareport.preview.btn" />
              </Button>
            </div>
          </div>
        </Card>
      </div>
    );
  }
  return (
    <div className="modalReportTable fx fh  p20">
      <DataReportTable
        getReportData={previewWidget}
        data={tableData}
        loading={reportLoading}
        previewConfig={data}
        setLoading={setReportLoading}
        meta={meta}
        source="CREATE"
      />
    </div>
  );
}

export default DataReportDetail;
